import Color from "./Color";


const TAU = Math.PI * 2;


function fract(number)
{
    return number - Math.floor(number);
}


export default function createParticleCanvas(width = 1024, height = 1024)
{
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = width;
    canvas.height = height;

    const num = 8;

    // ctx.fillStyle = "rgba(255,0,255,0)";
    // ctx.fillRect(0,0,width,height)

    const tile = width / num;
    const size = tile / 2;
    const max = tile * 0.2;


    const hueStart = 1/6;//Math.round(Math.random() * 6)/6;
                     
    for (let y = 0; y < height; y += tile)
    {
        for (let i = 0; i < num; i++)
        {
            const angle = Math.random() * TAU;
            const radius = Math.random() * max;

            const color = Color.fromHSL(
                (y < tile * 2 ? 0.83333: 0.33333) + (-1 + Math.random() * 2) * 0.15,//fract((hueStart + (Math.random() * 3)/3)),
                0.85,
                Math.min( 0.5 + 0.3 * i / num, 1)
            );
            ctx.fillStyle = `rgba(${color.r},${color.g},${color.b},${1 / (num - 1)})`;

            //console.log(ctx.fillStyle)
            for (let x = i * tile; x < width; x += tile)
            {
                ctx.fillRect(
                    x + 64 - size / 2 + Math.cos(angle) * radius,
                    y + 64 - size / 2 + Math.sin(angle) * radius,
                    size,
                    size
                );
            }
        }
    }
    return canvas;
}
